import { ImageOrigin, type MediaContent } from "mws-ts-v2-sdk";

type PhotoStudioBackgroundProduct = {
  media?: MediaContent[] | null;
  image360Url?: string | null;
};

export const usePhotoStudioBackground = (
  product: MaybeRefOrGetter<PhotoStudioBackgroundProduct | null | undefined>,
) => {
  const { isMatchWornShirt } = usePlatformStore();

  const has360Images = computed(() => {
    const productValue = toValue(product);
    if (!productValue) return false;

    const image360Url = productValue.image360Url;

    return typeof image360Url === "string" && image360Url.length > 0;
  });

  const hasMockupMedia = computed(() => {
    const productValue = toValue(product);
    const mediaArray = productValue?.media;
    if (!mediaArray || mediaArray.length === 0) return false;

    return mediaArray.some(
      (item) => item.metadata?.origin === ImageOrigin.Mockup,
    );
  });

  const showPhotoStudioBackground = computed(() => {
    if (!isMatchWornShirt) return false;

    const productValue = toValue(product);
    if (!productValue) return false;

    const hasMockups = hasMockupMedia.value;
    if (hasMockups) return true;

    return !has360Images.value;
  });

  return {
    productMediaBgClass: computed(() => {
      if (showPhotoStudioBackground.value) {
        return "photo-studio-background";
      }

      return "bg-platform-bg-2";
    }),
  };
};
